/* GH-1133 S5 (design §2.4): the free-preview route outlet, composed with
   PostingRouteOutlet (App.jsx) — PostingRouteOutlet hands over to this only
   while useFreePreview().active. Allowed routes render as today; /app/plans
   renders the board with the trial wall over it (never Plans.jsx, whose
   plain checkout has no trial); every other /app route gets S10. */
import React, { useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppShell } from '../AppShell';
import { Dashboard } from '../../screens/Dashboard.jsx';
import PreviewFeatureLock from './PreviewFeatureLock.jsx';
import { useFreePreview } from '../../contexts/FreePreviewContext.jsx';
import { useDashboardData } from '../../state/DashboardDataContext.jsx';
import { previewRouteDecision } from '../../lib/previewAccess.js';
import { freePublishingState } from '../../lib/freePublishing.js';

export default function PreviewRouteOutlet() {
  const { t } = useTranslation();
  const location = useLocation();
  const freePreview = useFreePreview();
  const dashboard = useDashboardData() || {};
  const ownContent = freePublishingState(dashboard.entitlementsError ? null : dashboard.entitlements || freePreview.entitlements);
  const ownRoute = location.pathname === '/app/create' || location.pathname === '/app/calendar'
    || /^\/app\/post\/[^/]+\/edit$/.test(location.pathname);
  const decision = ownContent && ownRoute ? { kind: 'allow' } : previewRouteDecision(location.pathname);
  const plansWallOpened = useRef(false);

  // /app/plans is reached by a user click (every "Upgrade"/"See plans" link);
  // it opens the wall once per visit of the route.
  useEffect(() => {
    if (decision.kind !== 'plans') { plansWallOpened.current = false; return; }
    if (plansWallOpened.current) return;
    plansWallOpened.current = true;
    freePreview.openTrialWall('cta', { fromPlansRoute: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [decision.kind]);

  if (decision.kind === 'plans') return <AppShell topbarTitle={t('topbar.dashboard')}><Dashboard /></AppShell>;
  if (decision.kind === 'lock') return <AppShell><PreviewFeatureLock feature={decision.feature} source={decision.source} /></AppShell>;
  return <Outlet key={dashboard.accountId} />;
}
